import { Color } from '@philips-emr/tws-constants';
import { ComponentAPI } from '@philips-emr/tws-core';
import { isEnumValid } from '@philips-emr/tws-utils';

import { StampIcon } from './constants';

class StampAPI extends ComponentAPI {

  getColor(): Color {
    return this.state.color;
  }

  setColor(color: Color): void {
    if (isEnumValid(Color, color)) {
      this.setState({ color });
    }
  }

  isEnableAutoHide(): boolean {
    return this.state.enableAutoHide;
  }

  setEnableAutoHide(enableAutoHide: boolean): void {
    this.setState({ enableAutoHide });
  }

  getIcon(): StampIcon {
    return this.state.icon;
  }

  setIcon(icon: string): void {
    if (isEnumValid(StampIcon, icon)) {
      this.setState({ icon });
    }
  }

  getLabel(): void {
    return this.state.label;
  }

  setLabel(label: string): void {
    this.setState({ label });
  }

}

export default StampAPI;

